'use strict'

var postcss = require('postcss')
var CleanCss = require('clean-css');

export default postcss.plugin('clean', ( opts ) => {
  if ( opts === void 0 ) opts = {};

  var cleancss = new CleanCss(opts);

  return function ( css, res ) {
	return new Promise( function( resolve, reject ) {

		cleancss.minify( css.toString(), function( err, min ) {
			if ( err ) {
				return reject( new Error( err.join( '\n' ) ) )
			}

			for ( var i = 0, list = min.warnings; i < list.length; i += 1 ) {
				var w = list[i];

				res.warn(w);
			}

			res.root = postcss.parse( min.styles );
			resolve();
		});
	})
  }
})


// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/postcss/postcss-clean.js